module.exports = __webpack_public_path__ + "static/media/F6.2ef8e230.jpg";